import React from 'react';
import { BookOpen } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 px-4 md:px-8 border-b border-warmBrown/20 bg-cream sticky top-0 z-50" data-id="element-69">
      <div className="max-w-3xl mx-auto flex flex-col items-center justify-center text-center" data-id="element-70">
        <div className="flex items-center gap-2 text-forestGreen mb-1" data-id="element-71">
          <BookOpen size={24} className="opacity-80" data-id="element-72" />
          <h1 className="font-handwritten text-3xl md:text-4xl font-bold tracking-wide" data-id="element-73">
            Napftagebuch
          </h1>
        </div>
        <p className="text-warmBrown/80 italic text-sm md:text-base font-serif" data-id="element-74">
          Ehrliche Geschichten aus dem Hundealltag
        </p>
      </div>
    </header>;
}